import { adminNavEntry } from 'src/modules/admin/adminTabRoutes';
import { debugNavEntry } from 'src/modules/debug/debugTabRoutes';
import { examPrepNavEntry } from 'src/modules/exam-preparation/examPreparationTabRoutes';
import { notificationNavEntry } from 'src/modules/notification/notificationTabRoutes';
import { reviewPipelineNavEntry } from 'src/modules/review-pipeline/reviewPipelineNavEntry';
import { stcNavEntry } from 'src/modules/support-the-creators/stcTabRoutes';
import { userNavEntry } from 'src/modules/user/userTabRoutes';
const ENTRIES_BY_ID = {
    [examPrepNavEntry.id]: examPrepNavEntry,
    [notificationNavEntry.id]: notificationNavEntry,
    [reviewPipelineNavEntry.id]: reviewPipelineNavEntry,
    [adminNavEntry.id]: adminNavEntry,
    [debugNavEntry.id]: debugNavEntry,
    [userNavEntry.id]: userNavEntry,
    [stcNavEntry.id]: stcNavEntry,
};
export const PRIMARY_NAV_REGISTRY = Object.values(ENTRIES_BY_ID);
const PLACEMENT_ORDER = {
    tab: ['ep', 'notification', 'user', 'stc', 'admin', 'debug'],
    'sidebar-main': ['ep', 'notification', 'rp', 'admin', 'debug'],
    'sidebar-footer': ['stc'],
    'sidebar-profile': ['user'],
};
export function getNavEntries(ctx, placement) {
    return PLACEMENT_ORDER[placement]
        .map(id => ENTRIES_BY_ID[id])
        .filter((entry) => !!entry && entry.isVisible(ctx));
}
